/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Change_ProfileInputs */

const en_change_profile = /** @type {(inputs: Change_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Profile`)
};

const de_change_profile = /** @type {(inputs: Change_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil bearbeiten`)
};

/**
* | output |
* | --- |
* | "Change Profile" |
*
* @param {Change_ProfileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const change_profile = /** @type {((inputs?: Change_ProfileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Change_ProfileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_change_profile(inputs)
	return en_change_profile(inputs)
});